import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import styles from "./WaitingPaymentAccount.module.css";
import CountdownTimer from "./CountDownTimer";
import SeperatorBlue from "../SeperatorBlue/SeperatorBlue.module";
import CtaBtns from "../CtaBtns/CtaBtns.module";

const arraysEqual = (a = [], b = []) =>
  a.length === b.length && a.every((v, i) => v === b[i]);

const WaitingPaymentAccount = ({
  reserveds = [],
  modalOpener,
  onPresenceChange,
  rootRef,
}) => {
  // 1) computeActiveIds پایدار
  const computeActiveIds = useCallback((list) => {
    const now = Date.now();
    // اگر ترتیب برایت مهم نیست می‌توانی sort هم بزنی تا مقایسه پایدارتر شود:
    return (list || [])
      .filter((r) => new Date(r.expireTime).getTime() > now)
      .map((r) => r.reserveId);
  }, []);

  // state اولیه فقط یک‌بار از props مشتق می‌شود
  const [activeIds, setActiveIds] = useState(() => computeActiveIds(reserveds));

  // 2) همگام‌سازی با تغییر reserveds، با گاردِ برابری
  useEffect(() => {
    const next = computeActiveIds(reserveds);
    setActiveIds((prev) => (arraysEqual(prev, next) ? prev : next));
  }, [reserveds, computeActiveIds]);

  const activeReserveds = useMemo(
    () => reserveds.filter((r) => activeIds.includes(r.reserveId)),
    [reserveds, activeIds]
  );

  const hasContent = activeReserveds.length > 0;
  const prevHasContent = useRef(hasContent);
  useEffect(() => {
    if (prevHasContent.current !== hasContent) {
      onPresenceChange?.(hasContent);
      prevHasContent.current = hasContent;
    }
  }, [hasContent, onPresenceChange]);

  const handleExpire = (id) => {
    setActiveIds((prev) => prev.filter((x) => x !== id));
  };

  if (!hasContent) return null;

  return (
    <>
      {" "}
      <div ref={rootRef} className={styles.waitingAccount}>
        {/* <div className={styles.maketwocol}>
        <div className={styles.waitingAccountDescers}>
          این اکانت ها تا ۳۰ دقیقه برای شما رزرو خواهند ماند. در صورت عدم
          پرداخت، اکانت ها به طور خودکار حذف می‌گردند.
        </div>
      </div> */}
        <div className={styles.boxOfTitle}>
          <div className={styles.referralTitle}>
            <i class="fa-solid fa-bag-shopping"></i>
            اکانت ها در انتظار پرداخت
          </div>
          <div className={styles.infoleft}>
            <i class="fa-regular fa-circle-info"></i>
          </div>
        </div>

        <div className={styles.paymentBtnPart}>
          {activeReserveds.map((acc) => (
            <EachWaiting
              key={acc.reserveId}
              reserveId={acc.reserveId}
              name={acc.name}
              price={acc.price}
              expireTime={acc.expireTime}
              onExpire={() => handleExpire(acc.reserveId)}
              modalOpener={() => modalOpener?.("payReserved", acc)}
            />
          ))}
        </div>
      </div>
      <SeperatorBlue />
    </>
  );
};

const EachWaiting = ({
  name,
  reserveId,
  price,
  expireTime,
  modalOpener,
  onExpire,
}) => {
  const [showAcc, setShowAcc] = useState(true);

  useEffect(() => {
    if (!showAcc) onExpire?.();
  }, [showAcc, onExpire]);

  if (!showAcc) return null;

  return (
    <div className={styles.eachAccountToPay}>
      <div className={styles.inPart}>
        <i class="fa-regular fa-address-card"></i>
        {name}
      </div>

      <div className={styles.price}>
        {Number(price ?? 0).toLocaleString("fa-IR")} تومان
      </div>

      <div className={styles.desOnWaiting}>
        <i className="fa-thin fa-exclamation-circle" />
        پس از پرداخت، پروفایل شما در پایین صفحه قابل دسترسی می‌باشد.
      </div>

      <div className={styles.expireTime}>
        مهلت پرداخت تا <br />
        <div className={styles.bolder}>
          <CountdownTimer
            targetTime={expireTime}
            onExpire={() => setShowAcc(false)}
          />
        </div>
      </div>

      <CtaBtns className={styles.goForPayment} onAtion={modalOpener}>
        پرداخت
      </CtaBtns>
    </div>
  );
};

export default WaitingPaymentAccount;
